import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ShopkeeperLayoutComponent } from "@app-components/layouts/shopkeeper-layout/shopkeeper-layout.component";
import { EvaluationProductsComponent } from "@app-components/evaluation/products/evaluation-products.component";
import { EvaluationFormPageComponent } from "@app-components/evaluation/form-page/evaluation-form-page.component";
import { EvaluationProductDetailComponent } from "@app-components/evaluation/evaluation-product-detail/evaluation-product-detail.component";
import { EvaluationHistoryPageComponent } from "@app-components/evaluation/evaluation-history-page/evaluation-history-page.component";
import { RoleGuard } from "@app-shared/guards/roles.guard";
import { Role } from "@app/store/session/session.store";
import { EvalLeadsComponent } from "@app-components/evaluation/eval-leads/eval-leads.component";
import { ImportEvaluationsComponent} from "@app-components//evaluation/import-evaluations/import-evaluations.component";
import { EvalsDashboardsComponent } from "../evals-dashboards/evals-dashboards.component";

const children = [
  {
    path: "maquinas",
    component: EvaluationProductsComponent,
    data: {
      pageTitle: "Máquinas em captação",
    },
  },
  {
    path: "maquinas/novo",
    component: EvaluationFormPageComponent,
  },
  {
    path: "maquinas/editar/:id",
    component: EvaluationFormPageComponent,
  },
  {
    path: "maquinas/:slug/:id",
    component: EvaluationProductDetailComponent,
  },
  {
    path: "importar",
    component: ImportEvaluationsComponent,
  },
  {
    path: "leads",
    component: EvalLeadsComponent,
    canActivate: [RoleGuard],
    data: {
      pageTitle: "Leads Plug-in RaioX",
      roles: [Role.SELLER_MANAGER, Role.ADMIN, Role.OEM_DEALER_MANAGER, Role.DESK_BUY, Role.SELLER, Role.EVAL_DEALER_MANAGER],
    },
  },
  {
    path: "historico",
    component: EvaluationHistoryPageComponent,
    canActivate: [RoleGuard],
    data: {
      pageTitle: "Histórico de captações",
      roles: [Role.SELLER_MANAGER, Role.ADMIN, Role.OEM_DEALER_MANAGER, Role.DESK_BUY, Role.EVAL_DEALER_MANAGER, Role.SUPER_EVALUATOR, Role.SELLER],
    },
  },
  {
    path: "",
    redirectTo: "/captar/maquinas",
    pathMatch: "full",
  },
  {
    path: "dashboards",
    component: EvalsDashboardsComponent
  },
];

const routes: Routes = [
  {
    path: "captar",
    component: ShopkeeperLayoutComponent,
    children,
  },
  {
    path: "avaliar",
    component: ShopkeeperLayoutComponent,
    children,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EvaluationRoutingModule { }
